import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login/login.component';
import { FxLoginBlockComponent } from './login/login-block/login-block.component';
import { ForgetModule } from './forget/forget.module';

import { NgQuicksilverModule } from 'ng-quicksilver';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DwIamPermissionInfoService} from "@webdpt/framework";
import { from } from 'rxjs';
import { FxLoingingService } from 'app/implementation/auth/fx-login.service';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgQuicksilverModule,
    TranslateModule,
    ForgetModule
  ],
  declarations: [
    LoginComponent,
    FxLoginBlockComponent,
    // FxLoingingService
  ],
  providers: [DwIamPermissionInfoService, FxLoingingService],
})
export class LoginModule { }
